import script from "./BalProgressBar.vue?vue&type=script&setup=true&lang=ts"
export * from "./BalProgressBar.vue?vue&type=script&setup=true&lang=ts"

import "./BalProgressBar.vue?vue&type=style&index=0&id=5bdd1331&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5bdd1331"]])

export default __exports__